export class InvalidDeck extends Error {}

export class TimeoutError extends Error {}
